import { createSelector } from 'reselect'
import sessionIdIsSetSelector from './sessionIdIsSetSelector'
import currentPathnameSelector from './router/currentPathnameSelector'
import { ROUTE_CHECK } from '../../constants/routes'
import trackingIsReadySelector from './tracking/trackingIsReadySelector'
import languageIsLoadedSelector from './i18n/languageIsLoadedSelector'
import isTrackingEnabledSelector from './feature-scope/isTrackingEnabledSelector'

const shallAppRenderSelector = createSelector(
    sessionIdIsSetSelector,
    currentPathnameSelector,
    trackingIsReadySelector,
    languageIsLoadedSelector,
    isTrackingEnabledSelector,
    (
        sessionIdSet,
        currentPathname,
        trackingIsReady,
        languageIsLoaded,
        isTrackingEnabled,
    ): boolean => {
        if (currentPathname === ROUTE_CHECK) {
            return true
        }

        // If tracking is enabled for this brand, wait for it to be ready
        if (isTrackingEnabled) {
            return trackingIsReady && sessionIdSet && languageIsLoaded
        }

        // If tracking is disabled for this brand, don't wait for tracking to be ready
        return sessionIdSet && languageIsLoaded
    },
)

export default shallAppRenderSelector
